module.exports = __webpack_public_path__ + "static/media/type-0.dfdfaa52.svg";